import { sidebarNodeTypes } from '../../../config/config';
import { BaseApi } from '../../common/api/base-api.interface';
import { ImageNodeCreateProps } from '../models/image-node-create-props';
import { getApiForNodeType } from './../../common/api/api-map';
import { createImageNode } from './create-image-node';
import { setupImageNode } from './setup-image-node';

export const imageNodeAPI = (): BaseApi<ImageNodeCreateProps> => ({
  name: sidebarNodeTypes.imageNode,
  setup: setupImageNode,
  create: createImageNode,
  getCursor: () => 'crosshair',
  ...getApiForNodeType(sidebarNodeTypes.imageNode),
});
